import { sumBy } from "lodash";

export default function(value) {
  return value.meals
    .map(({ name, dates = [] }) => `${name} (${sumBy(dates, "quantity")})`)
    .join(", ");
}
